/**
 * Created by lihanying on 2017/6/29.
 */
import { GETCLUBSTREAM, GETCLUBWALLETS } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBSTREAM:
      return Object.assign({}, state, { streamList: action.payload })
    case GETCLUBWALLETS:
      return Object.assign({}, state, { walletList: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubStream/reduce.js